import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.742 6.557A3 3 0 1 0 12 12h6.062l-.28-.401c-.909-1.305-1.821-2.615-2.845-3.832-.504-.597-.912-1.008-1.195-1.21ZM7 9c0 1.126.372 2.164 1 3H3v8h13v11h1.303L20 29.202 22.697 31H24V20h13v-8h-5a5 5 0 0 0-6.905-7.07c-.5.357-1.042.932-1.561 1.549-1.094 1.298-2.064 2.693-3.034 4.085l-.5.718-.5-.716c-.969-1.393-1.94-2.79-3.034-4.087-.52-.617-1.062-1.192-1.562-1.55A5 5 0 0 0 7 9Zm24 0a3 3 0 0 1-3 3h-6.062l.277-.398c.91-1.306 1.823-2.617 2.848-3.835.504-.597.912-1.008 1.195-1.21A3 3 0 0 1 31 9Zm-15 9v-4H5v4h11Zm8 0h11v-4H24v4Zm-2-4h-4v14.131l2-1.333 2 1.334V14ZM7 22v12h26V22h2v14H5V22h2Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var PictogramServicesGift40 = createIcon(IconComponent);